
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useAuth } from './AuthContext';
import App from './App';
import { postLogin } from './apiService';
import { jwtDecode } from 'jwt-decode';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaTimesCircle } from 'react-icons/fa';
import LoginPage from "./components/pages/logo/LoginPage.png";
import styled from 'styled-components';

const LoginForm = () => {
  const history = useHistory();
  const { isAuthenticated, login } = useAuth();
  const [companyCode, setCompanyCode] = useState('');
  const [companyId, setCompanyId] = useState('');
  const [branchId, setBranchId] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loginFailed, setLoginFailed] = useState(false);
  const [companyCodeValidated, setCompanyCodeValidated] = useState(false);
  const [companyName, setCompanyName] = useState('');
  const [branchstate, setbranchstate] = useState('');
  const location = useLocation();
  const [isAnimating, setIsAnimating] = useState(false);

  const handleCompanyValidation = async () => {
    try {
      // Implement company code validation logic here
      // For demonstration purposes, assume the company code is valid if it's not empty
      if (!companyCode.trim()) {
        //throw new Error('Company code is required.');
        toast.error('Branch code is required.', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 5000,
          style: {
            backgroundColor: '#e74c3c',
            color: '#fff',
            fontSize: '16px',
            fontWeight: 'bold',
            borderRadius: '10px',
            padding: '10px 20px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          },

        });
      }

      if (companyCode.trim()) {

        const CompanyData = {
          BranchCode: companyCode,
        };


        const response = await postLogin('BranchLoginApi', CompanyData);

        if (response.responseCode === '1111') {
          if (response.responseCode === '1111') {
            toast.success('Login successful!', {
              position: 'top-center',
              autoClose: 5000,
            });
          } else {
            toast.error('Invalid Branch code', {
              position: 'top-center',
              autoClose: 5000,
            });
          }
          setCompanyCodeValidated(true);
          setCompanyId(response.response_data.companyId)
          setBranchId(response.response_data.id)
          setCompanyName(response.response_data.name);
          setbranchstate(response.response_data.branchstate)
          setLoginFailed(false); // Reset loginFailed state
        } else {
          //throw new Error(response.Message);
          toast.error('Invalid Branch code', {
            position: toast.POSITION.TOP_CENTER,
          });
        }

      }


    } catch (error) {
      toast.error('Branch login failed', {
        position: 'top-center',
        autoClose: 5000,
      });
    }

  };


  useEffect(() => {
    setIsAnimating(true);
  }, []);

  const handleLogin = async () => {
    try {

      if (!companyCodeValidated) {
        throw new Error('Branch code validation is required.');
      }

      const jwtToken = await performLogin();
      const responseData = jwtDecode(jwtToken);
      const keysToRemove = ['iss', 'exp', 'ttp', 'http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name', 'aud'];
      const permissions = Object.keys(responseData).filter(
        (key) => key !== 'companyId' && key !== 'userId' && !keysToRemove.includes(key)
      );

      let isSuper = false;
      if (responseData.isSuperAdmin.toLowerCase() === "true") {
        isSuper = true;
      }

      let ispurchaseRequestNeeded = false;


      if (isSuper == false) {
        const parsedCompanyId = parseInt(responseData.companyId, 10);

        if (parsedCompanyId === companyId) {
          login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, companyName, permissions, jwtToken, responseData.roleName, branchstate, ispurchaseRequestNeeded);
          const redirectParam = new URLSearchParams(location.search).get("redirect");
          const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
          history.replace(redirectPath);
        }
        else {
          toast.error(
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <FaTimesCircle style={{ marginRight: '10px', fontSize: '20px' }} />
              Invalid User!
            </div>,
            {
              position: "top-center", // Position at the top center of the screen
              autoClose: 3000, // Auto close after 3 seconds
              hideProgressBar: true, // Hide the progress bar
              closeButton: true, // Show the close button
              style: {
                background: '#f44336', // Red background for error
                color: 'white', // White text color
                fontSize: '16px',
                padding: '12px 20px',
                borderRadius: '8px',
                textAlign: 'center',
                width: 'auto', // Auto width for the message
                maxWidth: '400px', // Maximum width for the message
                margin: '0 auto', // Center align the toast
              },
            }
          );
        }
      }
      else {
        login(responseData.companyId, responseData.branchId, responseData.userId, isSuper, responseData.superAdminCompanyId, companyName, permissions, jwtToken, responseData.roleName, branchstate, ispurchaseRequestNeeded);
        const redirectParam = new URLSearchParams(location.search).get("redirect");
        const redirectPath = redirectParam ? decodeURIComponent(redirectParam) : "/Home";
        history.replace(redirectPath);
      }


    } catch (error) {
      toast.error(
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <FaTimesCircle style={{ marginRight: '10px', fontSize: '20px' }} />
          Invalid User!
        </div>,
        {
          position: "top-center", // Position at the top center of the screen
          autoClose: 3000, // Auto close after 3 seconds
          hideProgressBar: true, // Hide the progress bar
          closeButton: true, // Show the close button
          style: {
            background: '#f44336', // Red background for error
            color: 'white', // White text color
            fontSize: '16px',
            padding: '12px 20px',
            borderRadius: '8px',
            textAlign: 'center',
            width: 'auto', // Auto width for the message
            maxWidth: '400px', // Maximum width for the message
            margin: '0 auto', // Center align the toast
          },
        }
      );
    }
  };

  const performLogin = async () => {
    const loginData = {
      UserName: username,
      Password: password,
      CompanyId: companyId,
      BranchId: branchId
    };

    const response = await postLogin('LoginApi', loginData);

    if (response.responseCode === '1111') {
      const jwtToken = response.response_data.token;

      return jwtToken;
    } else {
      throw new Error(response.Message);
    }
  };

  const closeModal = () => {
    setLoginFailed(false);
  };

  if (isAuthenticated) {
    return <App />;
  }


  return (
    <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "100vh",
      backgroundImage: `url(${LoginPage})`,
      backgroundSize: "cover",
    }}
  >
      <ToastContainer />
      <div
        style={{
          width: "100%",
          maxWidth: "420px",
          padding: "30px",
          borderRadius: "20px",
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)",
          background: "rgba(255, 255, 255, 0.85)",
          color: "#333",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            fontSize: "32px",
            fontWeight: "700",
            marginBottom: "2rem",
            color: "#2d2d2d",
            textShadow: "2px 2px 5px rgba(0, 0, 0, 0.3), -2px -2px 5px rgba(0, 0, 0, 0.3)",
          }}
        >
          LOGIN
        </h2>

        {!companyCodeValidated ? (
          <form onSubmit={(e) => { e.preventDefault(); handleCompanyValidation(); }}>
            <div style={{ marginBottom: "1.5rem" }}>
              <label style={{ fontSize: "16px", fontWeight: "500", color: "#555" }}>BRANCH CODE</label>
              <br />
              <input
                type="text"
                placeholder="Enter Branch Code"
                value={companyCode}
                onChange={(e) => setCompanyCode(e.target.value)}
                style={{
                  width: "80%",
                  padding: "12px",
                  marginTop: "8px",
                  border: "none",
                  borderRadius: "25px",
                  outline: "none",
                  boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.1)",
                  color: "#555",
                  fontSize: "16px",
                }}
              />
            </div>
            <button
              type="submit"
              style={{
                width: "50%",
                padding: "12px",
                borderRadius: "25px",
                background: "#007bff",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "600",
                transition: "background 0.3s",
              }}
            >
              <span style={{ marginRight: "0.5em" }}>Let Me In</span>
            </button>
          </form>
        ) : (
          <form onSubmit={(e) => { e.preventDefault(); handleLogin(); }}>
            <p
              style={{
                fontSize: "18px",
                fontWeight: "500",
                marginBottom: "20px",
                background: "linear-gradient(135deg, #FAD02E, #F26B38, #D83A56)",
                WebkitBackgroundClip: "text",
                color: "transparent",
                textAlign: "center",
                letterSpacing: "1px",
              }}
            >
              Welcome to {companyName}
            </p>

            <div style={{ marginBottom: "1.5rem" }}>
              <label style={{ fontSize: "16px", fontWeight: "500", color: "#555" }}>USERNAME</label>
              <br />
              <input
                type="text"
                placeholder="Enter Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                style={{
                  width: "80%",
                  padding: "12px",
                  marginTop: "8px",
                  border: "none",
                  borderRadius: "25px",
                  outline: "none",
                  boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.1)",
                  color: "#555",
                  fontSize: "16px",
                }}
              />
            </div>
            <div style={{ marginBottom: "2rem" }}>
              <label style={{ fontSize: "16px", fontWeight: "500", color: "#555" }}>PASSWORD</label>
              <br />
              <input
                type="password"
                placeholder="Enter Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  width: "80%",
                  padding: "12px",
                  marginTop: "8px",
                  border: "none",
                  borderRadius: "25px",
                  outline: "none",
                  boxShadow: "0px 6px 15px rgba(0, 0, 0, 0.1)",
                  color: "#555",
                  fontSize: "16px",
                }}
              />
            </div>
            <button
              type="submit"
              style={{
                width: "50%",
                padding: "12px",
                borderRadius: "25px",
                background: "#28a745",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                fontSize: "16px",
                fontWeight: "600",
                transition: "background 0.3s",
              }}
            >
              Login
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
export default LoginForm;
